import React from "react";
import { VariantProps } from ".";
import AddToCartToSeePrice from "./AddToCartToSeePrice";
import getPriceForGoogleView from "../getPriceForGoogleView";

const S = (props: VariantProps) => {
  const {
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    hasWebPlusDiscountedShipping,
    allowWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    price,
    isGoogleView,
    minimumBuy,
    mustBuy,
  } = props;

  return (
    <div className="map map-override mapS">
      <AddToCartToSeePrice
        mapPrice={
          isGoogleView
            ? getPriceForGoogleView({
                price: price.minimumAdvertisedPriceProperties.price,
                minimumBuy,
                mustBuy,
              })
            : price.minimumAdvertisedPriceProperties.price
        }
        price={
          isGoogleView
            ? getPriceForGoogleView({
                price: price.price,
                minimumBuy,
                mustBuy,
              })
            : price.price
        }
        hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping}
        allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping}
        hideWhyDoWeDoThis={price.hideWhyDoWeDoThis}
        isWebstaurantPlusEligible={isWebstaurantPlusEligible}
        showLoginLink={showBelowMinimumAdvertisedPriceForLoggedInCustomers}
        showDetails
        showDiscount
        showEnticement={isGoogleView}
        priceCrossedOut
        type={price.minimumAdvertisedPriceProperties.type}
        isGoogleView={isGoogleView}
      />
    </div>
  );
};

export default S;
